<template>
  <div class="bg-blue_header">
    <CCol sm="12" class="text-center" style="width: 98%;background-size: cover; margin: auto;">
      <CRow class="m-0 justify-content-center align-items-center">
        <br /><br /><br />

        
        <!-- <div class="bg-blue_header">
            <CCol sm="12" class="text-center" style="width: 98%;background-size: cover; margin: auto;"> -->
          <div class="header-top mt-4">
            <CRow>
              <span class="custom-header-profile">
                <img width="40px" height="40px" src="../assets/img/default-orange.png" />
              </span>
              <div style="text-align: left" class="ml-1">
                <span>
                  <h1 class="custom-12px m-0"> Welcome Back ! </h1>
                  <h3 class="custom-user text-white"> Hello {{user.name}} </h3>
                </span>
                <span>
                  <br /><br /><br />
                  <div style="position: absolute; top: 25px; right: 40px;">
                    <CButton type="button" class="button-border-orange text-white custom-12px mt-2" style="width:120px;height:30px">Supplier Mode</CButton>
                  </div>
                </span>
                <img style="position: absolute; top: 35px; right: 10px; max-width:20px" src="../assets/img/notification-white.png" @click="GoToNotification()" />
                <div style="clear: both"></div>
              </div>
            </CRow>
          </div>
          <!-- </CCol>
        </div> -->
        
        
      </CRow>
    
      <div class="">
        <CRow>
          <CCol sm="12">
            <div class="" style="
              border-radius: 12px;
              border: 1px solid rgba(229, 231, 235, 0.50);
              background: rgba(255, 255, 255, 0.20);  
                display: flex;
                width: 100%;
                padding: 13px;
                flex-direction: column;
                align-items: flex-start;
                gap: 10px;
                height:45px;" >
                <img src="../assets/img/iconsearch.png" style="width: 16px;"/>
                <input type="text" class="custom-12px text-white" style="margin-top: -25px; margin-left: 25px; color: #FAFAFA; background: transparent;  border: transparent;" placeholder="Search Services" /> 
              </div>
          </CCol>
        </CRow>
      </div>

      <br />
      
      <div class="m-0 justify-content-center align-items-center">
        <div class="bg-purple-card">
          <div class="header-top">
            <CRow class="m-1">
              <div style="text-align: left; position: relative;">
                <span>
                  <h1 class="custom-purple-text p-0"> RM 10.00 </h1>
                </span>
              </div>
              <div style="text-align:right;position: absolute;right:40px">
                <CButton type="button" class="button-border-blue text-white custom-12px" style="width:80px;height:30px">
                  Top Up!
                </CButton>
              </div>
            </CRow>
          </div>
        </div>
      </div>

      </CCol>
    
            
      <div class="bg-grey mt-2">
        <CCol sm="12" class="text-center " style="width: 98%;background-size: cover; margin: auto;">
            <div class="m-3">
                <br />
                <CRow>
                    <div style="width:50%">
                        <h1 class="custom-header-subtitle-sub-600 text-left">Services</h1>
                    </div>
                    <div style="width:50%">
                        <h1 class="custom-see-all text-right">See All</h1>
                    </div>
                </CRow>
            </div>
    
            <CRow class="justify-content-center m-0">
                <CCol style="
                                              display: flex;
                                              align-items: center;
                                              justify-content: center;
                                              padding:0px
                                            ">
                    <CCol sm="12" lg="12" style="
                                                  display: flex;
                                                  align-items: center;
                                                  justify-content: center;
                                                  left: 0;
                                                  right: 0;
                                                  bottom: 0px;
                                                  padding:0px;
                                                ">
                        <CCol sm="3" lg="3" class="p-0" style="width: 25%">
                            <CCol style="padding-left: 0px; padding-right: 0px;">
                                <br />
                                <img style="max-height:50px" src="../assets/img/homecleaning.png" />
                                <br />
                                <label class="text-icon custom-font-cards">
                                                        Home <br />Cleaning</label
                                                      >
                                                    </CCol>
                                                </CCol>
                            
                                                <CCol sm="3" lg="3" class="p-0" style="width: 25%">
                                                    <CCol style="padding-left: 0px; padding-right: 0px;">
                                                      <img style="max-height:50px" src="../assets/img/electrical.png" />
                                                      <br />
                                                      <label class="text-icon custom-font-cards"> Electrical <br /> </label>
                            </CCol>
                        </CCol>
    
                        <CCol sm="3" lg="3" class="p-0" style="width: 25%">
                            <CCol style="padding-left: 0px; padding-right: 0px;">
                                <img style="max-height:50px" src="../assets/img/electrical.png">
                                <br />
                                <label class="text-icon custom-font-cards">
                                                        Plumbing <br /> </label
                                                      >
                                                    </CCol>
                                                </CCol>
                            
                                                <CCol sm="3" lg="3" class="p-0" style="width: 25%">
                                                    <CCol style="padding-left: 0px; padding-right: 0px;">
                                                      <img style="max-height:50px" src="../assets/img/plumbinground.png" />
                                                      <br />
                                                      <label class="text-icon custom-font-cards">
                                                        Painting <br /> </label
                                                      >
                                                    </CCol>
                                                </CCol>
                                              </CCol>
                                            </CCol>
                                        </CRow>
                            
                                        <div class="m-3 mt-4">
                                            <CRow>
                                                <div style="width:50%">
                                                    <h1 class="custom-header-subtitle-sub-600 text-left">Most Popular</h1>
                                                </div>
                                                <div style="width:50%">
                                                    <h1 class="custom-see-all text-right">See All</h1>
                                                </div>
                                            </CRow>
            
                                            <CRow>
                                                <hooper
                                            settings="hooperSettings"
                                            ref="hooper"
                                            :itemsToShow="3"
                                            pagination="yes"
                                            style="height: 50px;"
                                          >
                                            <slide>
        
                                                <CButton type="button" class="button-border-blue text-white" style="width:80px">
                                           All
                                        </CButton>
                                        </slide>
                                        <slide>
                                            <label class="mt-2">
                                            Best Rating
                                        </label>
                                </slide>
                                <slide>
                                    <label class="mt-2">
                                            Promotion
                                            </label>
                                </slide>
    
                                <slide>
                                    <label class="mt-2">
                                            Partner
                                            </label>
                                </slide>
                                </hooper>
    
    
            </CRow>
    </div>
    
    <div class="mb-2">
        <hooper settings="hooperSettings" ref="hooper" :itemsToShow="1.5" pagination="yes" style="height: 255px;">
            <slide>
                <CCard style="border-radius: 10px; min-width:100%;" @click="GoToMap()">
                    <CCardBody>
                        <CRow class="m-1">
                            <span class="float-left">
                                                    <span>
                                                      <img
                                                        style="
                                                          max-width:100%
                                                        "
                                                        src="../assets/img/slide1.png"
                                                      />
                            
                                                      <span class="custom-type-exam ml-3">
                                                      <label class="text-black"><img style="max-width:15px" src="../assets/img/staricon.png" /> 4.8 <span class="custom-12px">(87)</span></label>
                            </span>
    
                            </span>
                            </span>
                            <h3 class="custom-header-subtitle-sub-600 ml-2 mr-2 text-left mt-2">Home Cleaning</h3>
                            <h4 class="custom-12px text-left ml-2 mr-2">Basic Cleaning will be provided</h4>
                            <CButton type="button" class="button-border-blue text-white ml-2 mr-2 mt-2" block>
                                Book Now
                            </CButton>
                        </CRow>
                    </CCardBody>
                </CCard>
            </slide>
    
            <slide class="ml-2">
                <CCard style="border-radius: 10px; min-width:100%;" @click="GoToMap()">
                    <CCardBody>
                        <CRow class="m-1">
                            <span class="float-left">
                                                    <span>
                                                      <img
                                                        style="
                                                          max-width:100%
                                                        "
                                                        src="../assets/img/slide1.png"
                                                      />
                            
                                                      <span class="custom-type-exam ml-3">
                                                      <label class="text-black"><img style="max-width:15px" src="../assets/img/staricon.png" /> 4.8 <span class="custom-12px">(87)</span></label>
                            </span>
    
                            </span>
                            </span>
                            <h3 class="custom-header-subtitle-sub-600 ml-2 mr-2 text-left mt-2">Home Cleaning</h3>
                            <h4 class="custom-12px text-left ml-2 mr-2">Basic Cleaning will be provided</h4>
                            <CButton type="button" class="button-border-blue text-white ml-2 mr-2 mt-2" block>
                                Book Now
                            </CButton>
                        </CRow>
                    </CCardBody>
                </CCard>
            </slide>
    
        </hooper>
    </div>
    
    
    <div class="mb-2">
        <hooper settings="hooperSettings" ref="hooper" :itemsToShow="1" pagination="yes">
            <slide>
                <CRow class="text-left pl-3">
                    <span class="float-left" style="position: relative; width: 100%;">
                                    <span>
                                        <img
                                            style="max-width:100%"
                                            src="../assets/img/Banner1.png"
                                        />
                                    </span>
    
                    <span style="position: absolute; top: 50%; left: 40%; transform: translate(-50%, -50%);">
                                        <span class="custom-user-title text-white text-left">Become a Services</span>
                    <label class="custom-label-warning text-left">More income with us</label>
                    <br />
                    <CButton type="button" class="custom-btn-register text-white mr-2 mt-2">
                        Register Now
                    </CButton>
                    </span>
                    </span>
                </CRow>
            </slide>
    
            <slide>
                <CRow class="text-left pl-3">
                    <span class="float-left" style="position: relative; width: 100%;">
                                    <span>
                                        <img
                                            style="max-width:100%"
                                            src="../assets/img/Banner1.png"
                                        />
                                    </span>
    
                    <span style="position: absolute; top: 50%; left: 40%; transform: translate(-50%, -50%);">
                                        <span class="custom-user-title text-white">Become a Services</span>
                    <label class="custom-label-warning">More income with us</label>
                    <br />
                    <CButton type="button" class="custom-btn-register text-white mr-2 mt-2">
                        Register Now
                    </CButton>
                    </span>
                    </span>
                </CRow>
            </slide>
    
            <hooper-navigation slot="hooper-addons"></hooper-navigation>
            <hooper-pagination slot="hooper-addons"></hooper-pagination>
        </hooper>
    </div>
    <br /><br /><br />
    </CCol>
</div>
    
    <MainlayoutBottom></MainlayoutBottom>
    
    </div>
</template>


<script>
import Vue from "vue";
import MainlayoutBottom from "../containers/TheBottomCustom.vue";
import {
    Hooper,
    Slide,
    Navigation as HooperNavigation,
    Pagination as HooperPagination,
} from "hooper";

import "hooper/dist/hooper.css";
export default ({
    components: {
        Hooper,
        Slide,
        HooperNavigation,
        HooperPagination,
        MainlayoutBottom,
    },
    data: function () {
        return {
            user: {},
            isLanguagePopupVisible: false,
            code: ["", "", "", ""],
            hooperSettings1: {
                hideArrows: true,
            },
            

        }

    },

    async mounted() {
        let isAuth = await this.UserAuth();

        if (isAuth) {
            this.Busy = false;
            this.GetInfoUser();
        } else {
            this.GoToLogin();
        }
    },

    methods: {
        GetInfoUser() {
        return this.$API
            .get(this.$LoginUserDetail, {
            withCredentials: true,
            })
            .then((response) => {
            if (response.status == 200) {
                this.user = response.data;
                console.log("userInfo", this.user);
            }
            });
        },

        GoToPrevious() {
            this.$router.go(-1);
        },

        GoToLogin() {
            // Close the popup and backdrop
            this.$router.push("/Login");
        },

        GoToChangePassword() {
            // Close the popup and backdrop
            this.$router.push("/ChangePassword");
        },
        submitVerification() {
            const verificationCode = this.code.join(""); // Concatenate the digits
            console.log("Verification Code:", verificationCode);

            this.popupSuccess = true;

            // Add your logic to handle the verification code
        },
        GoToMap()
        {
            this.$router.push("ChooseLocation")
        }

    }
})
</script>

<style scoped>
body {
    top: 0 !important;
    font-family: 'Poppins', sans-serif;
}
</style>